/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface MenuHoursGroupDefaultPut$Params {
  'Active-Tenant-Identifier': string;
  menuId: string;
  hoursId: string;
}

export function menuHoursGroupDefaultPut(http: HttpClient, rootUrl: string, params: MenuHoursGroupDefaultPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, menuHoursGroupDefaultPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('menuId', params.menuId, {});
    rb.path('hoursId', params.hoursId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

menuHoursGroupDefaultPut.PATH = '/menus/{menuId}/hours/{hoursId}/brand-menu';
